export enum EFileExtensions {
  CSV = '.csv',
  XLSX = '.xlsx',
  PDF = '.pdf'
}
